import { makeUIHeading1, makeUIHeading2, makeUIHeading3, makeUIHeading4, makeUIHeading5, makeUIHeading6 } from '../../../internal/typography/makeUIHeading';

/**
 * Компонент типографики для оформления заголовков в UI
 */
export const UIHeading1 = makeUIHeading1();

/**
 * Компонент типографики для оформления заголовков в UI
 */
export const UIHeading2 = makeUIHeading2();

/**
 * Компонент типографики для оформления заголовков в UI
 */
export const UIHeading3 = makeUIHeading3();

/**
 * Компонент типографики для оформления заголовков в UI
 */
export const UIHeading4 = makeUIHeading4();

/**
 * Компонент типографики для оформления заголовков в UI
 */
export const UIHeading5 = makeUIHeading5();
/**
 * Компонент типографики для оформления заголовков в UI
 */
export const UIHeading6 = makeUIHeading6();